export const getSegmentAnonymousId = () => {
  if (typeof window === 'undefined') return

  const user = window?.analytics?.user?.()
  if (user && typeof user.anonymousId === 'function') {
    return user.anonymousId()
  }
  return null
}
